import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTooltip,_vm._b({scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('span',_vm._g({},on),[_c(VBtn,{attrs:{"icon":!_vm.button.text && !_vm.button.fab,"disabled":_vm.button.disabled,"color":_vm.button.color,"fab":_vm.button.fab,"small":_vm.button.small,"dark":_vm.button.dark},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(" "+_vm._s(_vm.button.text)+" "),_c(VIcon,[_vm._v(_vm._s(_vm.button.icon))])],1)],1)]}}])},'v-tooltip',_vm.tooltip,false),[_vm._v(" "+_vm._s(_vm.tooltip.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }